import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const BRAND_COLLABORATIONS_SUB_CATEGORIES = [
  {
    title: 'Co-Branded Campaigns',
    description:
      'Joint marketing campaigns that combine two or more brands to reach wider audiences and share creative costs.',
  },
  {
    title: 'Cross-Promotions',
    description:
      'Mutual product features, bundle deals, and shared sampling opportunities between complementary brands.',
  },
  {
    title: 'Collaborative Product Launches',
    description:
      'Limited-edition co-created products, flavour collaborations, and joint innovation projects between aligned brands.',
  },
  {
    title: 'Shared Event Activations',
    description:
      'Multi-brand pop-ups, joint tastings, and collaborative event sponsorships that pool resources for bigger impact.',
  },
  {
    title: 'Influencer & Creator Partnerships',
    description:
      'Coordinated influencer campaigns where multiple brands collaborate on content, unboxings, and reviews.',
  },
  {
    title: 'Retail & Distribution Partnerships',
    description:
      'Joint retail placements, shared shelf space initiatives, and collaborative distribution agreements to expand reach.',
  },
];

export default function BrandCollaborationsThemePage() {
  return (
    <>
      <Head>
        <title>Brand Collaborations | Sizzle</title>
        <meta
          name="description"
          content="Cross-brand partnerships, co-branded campaigns, joint promotions, and collaborative product launches."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Brand Collaborations' }]}
        title="Brand Collaborations"
        description="Partner with complementary brands to amplify reach, share costs, and create memorable joint experiences. From co-branded campaigns to collaborative product launches — find your next brand partner here."
        heroImage="/static/themes/brand-collaborations-product-a-x-product-b.png"
        subCategoriesTitle="Collaboration opportunities"
        subCategoriesSubtitle="Discover ways to team up with other brands for mutual growth and shared audiences."
        subCategories={BRAND_COLLABORATIONS_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Brand collaboration initiatives from partners."
          categories={['trade']}
          limit={6}
          themes={['brand-collaborations']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          subtitle="Brands open to collaboration opportunities."
          roles={['brand', 'supplier']}
          limit={8}
          themes={['brand-collaborations']}
        />
      </ThemePage>
    </>
  );
}
